import React from "react";
import { FormattedMessage } from "react-intl";
import UserSessionList from "./user_session/UserSessionList";
import { TitledContent } from "./TitledContent";
import CRUDFormDialog from "./CRUDFormDialog";
import { useLoaderData, useRevalidator } from "react-router-dom";
import { useUserData } from "../context/UserDataProvider";
import { Button } from "@mui/material";
import { fetchData } from "./user_session/common";
import { FetchFunction } from "./FetchProvider";

export async function accountSessionsLoader(fetch: FetchFunction) {
    return await fetchData(null, fetch);
}

const AccountSessionsPage = () => {
    const userData = useUserData();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const revalidator = useRevalidator();
    const rows: any = useLoaderData();

    return (
        <>
            <TitledContent
                title={<FormattedMessage id="user.sessions" />}
                action={
                    <Button variant="contained" size="small" onClick={() => setDialogOpen(true)}>
                        <FormattedMessage id="token.createService" />
                    </Button>
                }
            >
                <UserSessionList rows={rows} />
            </TitledContent>
            <CRUDFormDialog
                open={dialogOpen}
                titleId="token.create"
                hide={() => setDialogOpen(false)}
                resourceName="token"
                action="create"
                extraRequestData={{ refresh_token_expires_in: 0, user: userData.userId }}
                onSuccess={() => {
                    setDialogOpen(false);
                    revalidator.revalidate();
                }}
            />
        </>
    );
};

export default AccountSessionsPage;
